var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('img',{style:({ width: '200px', height: '200px' }),attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('HelloWorld',{attrs:{"msg":"Welcome to Nazku"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }